import React, { useState } from 'react';
import '../../asstes/css/sass/Sidebar.scss';
import { Link } from 'react-router-dom';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapseToggle = () => {
    setIsCollapsed((prev) => !prev);
  };

  const handleLinkClick = () => {
    if (isCollapsed) {
      setIsCollapsed(false);
    }
  };

  return (
    <>
      <button
        id="toggle-button"
        className={isCollapsed ? 'collapsed' : ''}
        onClick={handleCollapseToggle}
      >
        {isCollapsed ? (
          <span className="fa fa-arrow-left"> Show</span>
        ) : (
          <span className="fa fa-arrow-right"> Hide</span>
        )}
      </button>

      <div className={`s-soft ${isCollapsed ? 'so-collapse' : ''}`}>

        <div className="list-group">
          <Link className="list-group-item" to="/USA/upcomingevents"><i className="fa fa-calendar fa-fw" aria-hidden="true"></i>&nbsp; Event</Link>
          <Link className="list-group-item" to="/USA/ActivityCalendar"><i className="fa flaticon-calendar fa-fw" aria-hidden="true"></i>&nbsp; YK Calendar</Link>
          <Link className="list-group-item" to="/USA/wordsofwisdom"><i className="fa fa-book fa-fw" aria-hidden="true"></i>&nbsp; Words of Wisdom </Link>
          <Link className="list-group-item" to="https://donationusa.yugalkunj.org/rms/"><i className="fa fa-moneyfas fa-dollar-sign" aria-hidden="true"></i>&nbsp; &nbsp; Donate Now </Link>

        </div>
        {/* <ul className="sidebarmenu">
          <li>   
            <Link to=" /USA/OurEvent" className="s-item facebook" onClick={handleLinkClick}>
          Events
        </Link></li>

        <li>   
            <Link to="/USA/ActivityCalendar" className="s-item facebook" onClick={handleLinkClick}>
          YK Calendar
        </Link></li>
        

        <li>
        <Link to="/" className="s-item facebook" onClick={handleLinkClick}>
         Classes
        </Link>
        </li>


        </ul> */}



      </div>
    </>
  );
};

export default Sidebar;
